import { createReducer } from 'redux-act';
import {
  setPortfoliosOverviewPage,
  setPortfoliosOverviewSearch,
  setPortfoliosOverviewSort,
  resetPortfoliosOverviewUi
} from './../../actions/portfoliosOverviewUi';

export interface IPortfoliosOverviewUiState {
  currentPage: number;
  search: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

const DEFAULT_SORT_BY = 'updatedAt';
const DEFAULT_SORT_ORDER: 'asc' | 'desc' = 'asc';

const readStoredSort = (): { sortBy: string; sortOrder: 'asc' | 'desc' } => {
  try {
    const raw = localStorage.getItem('portfolioOverviewSorting');

    if (!raw) {
      return { sortBy: DEFAULT_SORT_BY, sortOrder: DEFAULT_SORT_ORDER };
    }
    const parsed = JSON.parse(raw);
    const dir = parsed?.direction;
    const sortOrder: 'asc' | 'desc' =
      dir === 'asc' || dir === 'desc' ? dir : DEFAULT_SORT_ORDER;

    return { sortBy: parsed?.column || DEFAULT_SORT_BY, sortOrder };
  } catch (e) {
    return { sortBy: DEFAULT_SORT_BY, sortOrder: DEFAULT_SORT_ORDER };
  }
};

const initState: IPortfoliosOverviewUiState = {
  currentPage: 0,
  search: '',
  ...readStoredSort()
};

export const portfoliosOverviewUi = createReducer({}, initState);

portfoliosOverviewUi.on(setPortfoliosOverviewPage, (state, currentPage) => ({
  ...state,
  currentPage
}));

portfoliosOverviewUi.on(setPortfoliosOverviewSearch, (state, search) => ({
  ...state,
  search
}));

portfoliosOverviewUi.on(setPortfoliosOverviewSort, (state, { sortBy, sortOrder }) => ({
  ...state,
  sortBy,
  sortOrder
}));

portfoliosOverviewUi.on(resetPortfoliosOverviewUi, () => ({
  currentPage: 0,
  search: '',
  ...readStoredSort()
}));
